"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceAdaptor = void 0;
const ResourceAdaptor = (resources) => {
    try {
        if (Array.isArray(resources)
            && resources.length > 0
            && resources[0].Resources) {
            return resources[0].Resources.reduce((accumulator, currentValue) => {
                var _a, _b;
                if (currentValue === null || currentValue === void 0 ? void 0 : currentValue.Name) {
                    accumulator[currentValue.Name] = ((_b = (_a = currentValue === null || currentValue === void 0 ? void 0 : currentValue.ResourceValues) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.Value);
                }
                return accumulator;
            }, {});
        }
        return {};
    }
    catch (_a) {
        return {};
    }
};
exports.ResourceAdaptor = ResourceAdaptor;
//# sourceMappingURL=resource-adapt.js.map